import TextField from '../TextField'
import Select from '../Select'
import { noMask, parseDateCalendar } from './masks'

import * as S from './styles'
import { useEffect, useState } from 'react'
import CalendarDatePicker from '../CalendarDatePicker'
import addDays from 'date-fns/addDays'
import { set } from 'date-fns'

const Filter = ({
  click,
  opcoes,
  pedido,
  promotor,
  small,
  gimplus,
  setShowMenu,
  calendarModal
}) => {
  const [dataInicial, setDataInicial] = useState('')
  const [dataFinal, setDataFinal] = useState('')
  const [numero, setNumero] = useState()
  const [opcaoFiltro, setOpcaoFiltro] = useState('')

  useEffect(() => {
    !!promotor && setOpcaoFiltro(promotor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promotor])

  return (
    <>
      <div>
        <S.ProfileFilterContent small={small}>
          {!!opcoes && (
            <div className="form-group">
              <Select
                options={opcoes}
                label={!!gimplus ? 'Operação' : 'Status'}
                labelFor="Status"
                value={opcaoFiltro}
                onChange={(e) => setOpcaoFiltro(e.currentTarget.value)}
              ></Select>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="">{!!pedido ? 'Pedido' : 'Número'}</label>
            <TextField
              placeholder={!!pedido ? 'Pedido' : 'Número'}
              maxlength={9}
              value={numero}
              onChange={(e) => setNumero(noMask(e.currentTarget.value))}
            />
          </div>

          <div className="form-group">
            <label htmlFor="">Período</label>
            {/*
            <TextField
              placeholder="De"
              value={dataInicial}
              onChange={(e) => setDataInicial(dateMask(e.currentTarget.value))}
            /> */}

            <CalendarDatePicker
              dataInicial={dataInicial}
              setDataInicial={setDataInicial}
              dataFinal={dataFinal}
              setDataFinal={setDataFinal}
              rightSide
              promotor={!!promotor}
              range
              calendarModal={calendarModal}
            />
          </div>

          {/* <FormGroup className="form-group no-label">
            <label htmlFor=""></label>
            <TextField
              placeholder="Até"
              value={dataFinal}
              onChange={(e) => setDataFinal(dateMask(e.currentTarget.value))}
            />
          </FormGroup> */}

          <S.FilterButton
            onClick={() => {
              click(
                opcaoFiltro,
                numero,
                parseDateCalendar(
                  set(dataInicial, {
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                  })
                ),
                !!promotor
                  ? parseDateCalendar(
                      set(dataFinal, {
                        hours: 23,
                        minutes: 59,
                        seconds: 59
                      })
                    )
                  : parseDateCalendar(
                      set(dataFinal, {
                        hours: 23,
                        minutes: 59,
                        seconds: 59
                      })
                    )
              )
              !!setShowMenu && setShowMenu(false)
            }}
          >
            Filtrar
          </S.FilterButton>
        </S.ProfileFilterContent>
      </div>
    </>
  )
}

export default Filter
